import { PointYOptional } from '../../../common/maths/geometry/pointTypes';
import { ELEMENT_RESIZE_INTERPOLATION_FACTOR } from '../../element/resizing/store/resizingConstants';

const determineNextFrame = (from: PointYOptional, to: PointYOptional) => {
    if (!from.x || !to.x) return null;

    if (Math.abs(to.x - from.x) < 0.1 && (!from.y || !to.y || Math.abs(to.y - from.y) < 0.1)) return to;

    const x = (to.x - from.x) * ELEMENT_RESIZE_INTERPOLATION_FACTOR + from.x;
    if (!from.y || !to.y) return { x };

    const y = (to.y - from.y) * ELEMENT_RESIZE_INTERPOLATION_FACTOR + from.y;
    return { x, y };
};

export const animatePointTransition = (
    from: PointYOptional,
    to: PointYOptional,
    updatePoint: (point: PointYOptional) => void,
    animationFrameFunction = requestAnimationFrame,
    onComplete?: () => void,
) => {
    const newFrom = determineNextFrame(from, to);
    if (!newFrom) return onComplete?.();

    updatePoint(newFrom);

    if (newFrom.x === to.x && newFrom.y === to.y) return onComplete?.();

    animationFrameFunction(() => animatePointTransition(newFrom, to, updatePoint, animationFrameFunction, onComplete));
};
